module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBold.8574fdb.ttf";